import { fmt, spaceWords } from './util.js';

export default function Library({ spaces, onOpen, onNew }) {
  return (
    <div className="scroll">
      <div className="desk">
        <h1 className="desk-title">Your desk</h1>
        <p className="desk-sub">
          {spaces.length === 1 ? 'One space' : `${spaces.length} spaces`}, one quiet place to write.
        </p>
        <div className="space-grid">
          {spaces.map(sp => (
            <button className="space-card" key={sp.id} onClick={() => onOpen(sp)}>
              <div className="space-kind">{sp.kind}</div>
              <div className="space-name">{sp.name}</div>
              <div className="space-desc">{sp.description}</div>
              <div className="space-recent">
                {sp.docs.slice(-3).reverse().map(d => (
                  <div className="recent-line" key={d.id}>— {d.title || 'Untitled'}</div>
                ))}
              </div>
              <div className="space-foot">
                {sp.docs.length}{sp.id === 'journal' ? ' entries' : ' documents'} · {fmt(spaceWords(sp))} words
              </div>
            </button>
          ))}
          <button className="space-card is-new" onClick={onNew}>
            <div className="space-new-plus">+</div>
            <div className="space-new-label">New space</div>
          </button>
        </div>
      </div>
    </div>
  );
}
